import React from "react";
import PropTypes from "prop-types";
import I18n from "lib/i18n";
import AdminAction from "components/AdminAction";

const AdminMenuEntries = ({ adminActions }) => {
  if (!adminActions.length) {
    return null;
  }

  return (
    <React.Fragment>
      <li>
        <hr />
        <h4>{I18n.t("top_bar.label.admin")}</h4>
      </li>
      {adminActions.map(adminAction =>
        <AdminAction key={adminAction.path} {...adminAction} />
      )}
    </React.Fragment>
  );
};

AdminMenuEntries.propTypes = {
  adminActions: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    trackAction: PropTypes.string.isRequired,
  })).isRequired,
};

export default AdminMenuEntries;
